<template>
	<div :class="[baseClasses, $attrs.class]">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'

const props = defineProps({
	size: {
		type: String as PropType<'large' | 'medium'>,
		default: 'medium',
	},
	type: {
		type: String as PropType<'primary' | 'secondary'>,
		default: 'primary',
	},
})

const baseClasses = computed(() => {
	const typeClasses = {
		primary: 'rounded-lg border border-n-100 flex p-8px gap-8px',
		secondary: 'flex gap-8px',
	}

	const sizeClasses = {
		primary: {
			medium: 'gap-16px',
			large: 'mdl:gap-12px',
		},
		secondary: {
			medium: 'gap-16px',
			large: 'mdl:gap-12px',
		},
	}

	return [typeClasses[props.type], sizeClasses[props.type][props.size]]
})
</script>
